import { asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../_virtual/_rollupPluginBabelHelpers.js';
var copyTextFromElement = function copyTextFromElement(selector, container) {
  var field = document.querySelector(selector);
  return copyText(field.textContent.toString(), container);
};
var copyText = function copyText(text) {
  var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  try {
    var textArea = document.createElement('textarea');
    textArea.value = text;
    container.appendChild(textArea);
    textArea.select();
    textArea.focus();
    document.execCommand('copy');
    textArea.remove();
    window.getSelection().removeAllRanges();
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Copy to clipboard with new Clipboard API if available.
 * @param {string} text Data to be written
 * @returns true if action was successful.
 */
var copyToClipboard = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee(text) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return window.navigator.clipboard.writeText(text);
        case 1:
          return _context.a(2, true);
        case 2:
          _context.p = 2;
          _context.v;
          return _context.a(2, false);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function copyToClipboard(_x) {
    return _ref.apply(this, arguments);
  };
}();
export { copyText, copyTextFromElement, copyToClipboard };